import React from 'react';

const TONE = {
  positive: 'bg-emerald-100 text-emerald-800', neutral: 'bg-slate-100 text-slate-700', negative: 'bg-rose-100 text-rose-800',
  hot: 'bg-orange-100 text-orange-800', warm: 'bg-amber-100 text-amber-800', cold: 'bg-sky-100 text-sky-800',
};
const INTENT = { interested: 'Interested', meeting_request: 'Wants a meeting', question: 'Question', objection: 'Objection', not_now: 'Not now', not_interested: 'Not interested', unsubscribe: 'Asked to stop', other: 'Other' };

const Pill = ({ cls, children, testid }) => <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${cls}`} data-testid={testid}>{children}</span>;

export function Tags({ a, style, compact }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={compact ? undefined : 'coach-tags'}>
      <Pill cls={TONE[a.temperature]} testid={compact ? undefined : 'coach-temperature'}>{a.temperature}</Pill>
      <Pill cls={TONE[a.sentiment]} testid={compact ? undefined : 'coach-sentiment'}>{a.sentiment}</Pill>
      <Pill cls="bg-muted text-foreground" testid={compact ? undefined : 'coach-intent'}>{INTENT[a.intent] || a.intent}</Pill>
      {!compact && style && <Pill cls="bg-primary/10 text-primary" testid="coach-style">{style === 'nepq' ? `NEPQ${a.objection ? ` · objection: ${a.objection}` : ''}` : 'Hormozi'}</Pill>}
    </div>
  );
}
